module.exports = __webpack_public_path__ + "static/media/details-19-image-1.f337901a.jpg";